import { CommonModule } from '@angular/common';
import { Component, EventEmitter, OnInit, Output } from '@angular/core';
import { FormGroup, FormsModule, ReactiveFormsModule, UntypedFormBuilder, UntypedFormControl, Validators } from '@angular/forms';
import { Router, RouterModule } from '@angular/router';
import * as moment from 'moment-timezone';
import { CountryISO, NgxIntlTelInputModule, PhoneNumberFormat, SearchCountryField } from 'ngx-intl-tel-input';
import { NgxStarsModule } from 'ngx-stars';
import { ToastrService } from 'ngx-toastr';
import { HttpService } from '../../../service/http.service';
import { GlobalService } from '../../../service/global.service';

declare var $: any;
@Component({
  selector: 'app-call-form',
  standalone: true,
  imports: [
   CommonModule, FormsModule, ReactiveFormsModule, NgxIntlTelInputModule
  ],
  templateUrl: './call-form.component.html',
  styleUrl: './call-form.component.css'
})
export class CallFormComponent implements OnInit {

  @Output()
  close = new EventEmitter();

  hours = ['01', '01', '02', '03', '04', '05', '06', '07', '08', '09', '10', '11', '12', '13', '14', '15', '16', '17', '18', '19', '20', '21', '22', '23'];

  minutes: number[] = [];

  PhoneNumberFormat = PhoneNumberFormat;
  SearchCountryField = SearchCountryField;
  CountryISO = CountryISO;
  preferredCountries: CountryISO[] = [CountryISO.India];

  @Output()
  success = new EventEmitter<boolean>();


  date: string | undefined;
  status: any;
  astrologerData: any;
  userId: any;
  formData: any;
  chatQueueData: any;

  userChatIntakeForm: FormGroup;

  constructor(
    private _homeService: HttpService,
    private toastr: ToastrService,
    private formBuilder: UntypedFormBuilder,
    private router: Router,
    public gS: GlobalService
  ) {
    this.date = ""; //for date-picker


    console.log("Imincall");
    for (let i: any = 1; i <= 60; i++) {
      this.minutes.push(i);
    }

    this.userChatIntakeForm = this.formBuilder.group({
      name: new UntypedFormControl("", Validators.required),
      customerMobile: new UntypedFormControl("", Validators.required),
      countryCode: new UntypedFormControl(""),
      birtDate: new UntypedFormControl("", Validators.required),
      birthTime: new UntypedFormControl("", Validators.required),
      birthPlace: new UntypedFormControl("", Validators.required),
      gender: new UntypedFormControl("", Validators.required),
      userComment: new UntypedFormControl(),
      astrologerId: new UntypedFormControl()
    });



  }



  ngOnInit(): void {

    const todayDate = new Date();

    this.userId = this.gS.customerId;
    console.log(this.userId);

    this.astrologerData = localStorage.getItem("ap-astro-palm-detail");
   
    this.astrologerData = JSON.parse(this.astrologerData);
    console.log(this.astrologerData, 'astroDaTA');
    console.log(this.astrologerData.id);
    this.getPrefillFormData();

  }

  getPrefillFormData() {

    this._homeService.getCallFormPrefillData(this.userId).subscribe((data: any) => {

      if (data?.status == "success") {

        this.userChatIntakeForm = this.formBuilder.group({
          name: new UntypedFormControl(data?.data?.customerName, Validators.required),
          customerMobile: new UntypedFormControl(data?.data?.customerMobile, Validators.required),
          countryCode: new UntypedFormControl(data?.data?.countryCode),
          birtDate: new UntypedFormControl(new Date(data?.data?.birthDate), Validators.required),
          birthTime: new UntypedFormControl(data?.data?.birthTime),
          birthPlace: new UntypedFormControl(data?.data?.birthPlace, Validators.required),
          gender: new UntypedFormControl(data?.data?.gender, Validators.required),
          userComment: new UntypedFormControl(),
          astrologerId: new UntypedFormControl()
        });
      }
    }, (error) => {
      console.log(error);
    });
  }


  onTimeChange(value: any) {
    if (new Date(value)) {
      let date = new Date(value);
      let time = date.getHours() + " " + date.getMinutes();
      console.log(date.getHours(), date.getMinutes(), date.getUTCDate())
    }
    //  this.newTime=`${value.hour}:${value.minute}`;
  }

  onSubmit(): void {
    if (this.userChatIntakeForm.valid) {

      this.userChatIntakeForm.value.userId = this.userId;
      this.userChatIntakeForm.value.zoneType = this.gS.timeZone;

      this.userChatIntakeForm.value.astrologerId = this.astrologerData?.id;
      this.userChatIntakeForm.value.countryCode = this.userChatIntakeForm.value?.customerMobile?.dialCode
      this.userChatIntakeForm.value.customerMobile = this.userChatIntakeForm.value?.customerMobile?.number
      console.log(this.userChatIntakeForm.value);
      // return ;
      if (this.userChatIntakeForm.value.countryCode != '+91' && this.userChatIntakeForm.value.countryCode != '') {
        this.toastr.error("Currently this service available in India.", "Opps!");
        return;
      }
      this._homeService.userCallFormSubmit(this.userChatIntakeForm.value).subscribe((data: any) => {

        if (data?.status == "success") {
          console.log(data.data.orderId);
          // return;
          this._homeService.joinQueueCall(this.astrologerData, data.data.orderId, this.userChatIntakeForm.value).subscribe((data: any) => {
            console.log(data);
            this.chatQueueData = data;
            localStorage.setItem('chat_order_data', JSON.stringify(this.chatQueueData.data));
            //  console.log(localStorage.getItem('chat_order_data'));

            console.log(this.chatQueueData.status);

            if (this.chatQueueData.status == "success") {
              this.toastr.success("You have placed call order successfully, you will get call shortly.", "Success!");
              this.success.emit(true);

              // this.router.navigate(['/astroapp-user-astrologer-chat'])
            } else {
              this.toastr.error(data?.reason, "Opps!");
            }

          }, (error) => {
            console.log("error");

          })
        }

      }, (error) => {
        this.toastr.error("Something went wrong, please try again", "Failed to login");
        console.log(error);
      });
    }

  }


  handleOffcanvasClose() {
    console.log('Offcanvas closed!');
    this.close.emit(true);
    // Add your logic here when the offcanvas is closed
  }
}
